import { render, staticRenderFns } from "./AppMetricCard.vue?vue&type=template&id=3622120f&scoped=true"
import script from "./AppMetricCard.vue?vue&type=script&lang=js"
export * from "./AppMetricCard.vue?vue&type=script&lang=js"
import style0 from "./AppMetricCard.vue?vue&type=style&index=0&id=3622120f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3622120f",
  null
  
)

export default component.exports